<template>
    <asli-popup :show-close-button="true" v-model="displayModal" class="p-4">
        <div class="px-8 py-4">
            <asli-section-header class="my-[15px]">Quote already Purchased</asli-section-header>
            <p class="text-sm mb-[15px]">
                This quote has already been purchased. If you wish to manage your policy, please login to your online
                portal. Or if you require different cover please start a new quote.
            </p>
            <button-bar class="flex-col sm:flex-row">
                <asli-button id="new-quote" color="secondary" type="button" @click="goToLoginPage">Login</asli-button>
                <asli-button id="new-quote" color="primary" type="button" @click="goToHomePage">
                    Start a New Quote
                </asli-button>
            </button-bar>
        </div>
    </asli-popup>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { AsliPopup, AsliButton, AsliSectionHeader } from "@mbs-npm/anpost-ui";
import { useMainStore } from "@/stores/main";
import { useProposalStore } from "@/stores/risk/risk";
import router from "@/router";
import { FORM_MODE, ROUTE_NAMES } from "@/router/types";
import { FormRouteName } from "@/router/utils";
import { LOGIN_URL } from "@/static/constants";
import ButtonBar from "@/components/ButtonBar.vue";

const proposalStore = useProposalStore();
const mainStore = useMainStore();

const displayModal = computed({
    get: () => mainStore.displayQuoteAcceptedModal,
    set: val => (mainStore.displayQuoteAcceptedModal = val)
});

function goToHomePage() {
    displayModal.value = false;
    proposalStore.resetProposal();
    router.push({ name: FormRouteName(ROUTE_NAMES.AboutYou, FORM_MODE.CREATE) });
}

function goToLoginPage() {
    displayModal.value = false;
    window.location.href = LOGIN_URL;
}
</script>
